import React, { Component } from 'react';

export default class AllEvents extends Component {
  // TODO: wap header to be integrated with functionalities
  render() {
    this.windwidth = '';
    this.windwidth = window.innerWidth;
    const style1 = {
      left: this.windwidth,
    };
    const { otherActiveEvents } = this.props;
    return (
      <div className="col-xs-12">
        <div className="myEventsMenu" style={style1}>
          <div className="addGiftMenu">
            <ul>
              {otherActiveEvents}
            </ul>
          </div>
        </div>
      </div>
    );
  }
}

